export const PREFIX = "RM-";

export function getMerchantCodeWithPrefix(merchantCode){
    return PREFIX  + merchantCode;
}